// Adapted from stride-components utils (c) Stride.one
// Generates different russian word versions depending on the number before it.
// Usage for the word 'Зуб': return declOfNum(3, ['зуб', 'зуба', 'зубов'] – 1 зуб, 2 зуба, 5 зубов.

const declOfNum = (number, titles) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
};

export default declOfNum;
